import { c as _c } from "react/compiler-runtime";
import type { ItemUI } from '@libs/common-node';
import { useCart } from './useCart';
type Frequency = Pick<ItemUI, 'autoshipFrequency' | 'autoshipFrequencyUnitOfMeasure'>;
type PreviewItem = Pick<ItemUI, 'id' | 'listPrice' | 'quantity'>;
type UseOptimizelyFreeShipThresholdParams = Frequency & {
  previewItem?: PreviewItem;
};
const FREE_SHIPPING_THRESHOLD = 49;
const AUTOSHIP_DISCOUNT_MULTIPLIER = 0.95;
export const useOptimizelyFreeShipThreshold = t0 => {
  const $ = _c(7);
  const {
    autoshipFrequency,
    autoshipFrequencyUnitOfMeasure,
    previewItem
  } = t0;
  const {
    cart
  } = useCart();
  let t1;
  if ($[0] !== autoshipFrequency || $[1] !== autoshipFrequencyUnitOfMeasure || $[2] !== cart?.fulfillmentGroups || $[3] !== previewItem?.id) {
    t1 = cart?.fulfillmentGroups?.flatMap(_temp).filter(item => item.id !== previewItem?.id).filter(item_0 => Number(item_0.autoshipFrequency) === Number(autoshipFrequency) && Number(item_0.autoshipFrequencyUnitOfMeasure) === Number(autoshipFrequencyUnitOfMeasure)).reduce(_temp2, 0) ?? 0;
    $[0] = autoshipFrequency;
    $[1] = autoshipFrequencyUnitOfMeasure;
    $[2] = cart?.fulfillmentGroups;
    $[3] = previewItem?.id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const autoshipSubtotal = t1;
  const previewSubtotal = previewItem ? previewItem.listPrice * previewItem.quantity : 0;
  const discountedAutoshipSubtotal = (autoshipSubtotal + previewSubtotal) * AUTOSHIP_DISCOUNT_MULTIPLIER;
  const t2 = Math.max(0, Math.floor((FREE_SHIPPING_THRESHOLD - discountedAutoshipSubtotal) * 100) / 100);
  let t3;
  if ($[5] !== t2) {
    t3 = t2.toFixed(2);
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const shipThreshold = t3;
  return shipThreshold;
};
function _temp(t0) {
  const {
    items
  } = t0;
  return items;
}
function _temp2(subtotal, t0) {
  const {
    listPrice,
    quantity
  } = t0;
  return subtotal + listPrice * quantity;
}